(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFrame(frame) {
      if (frame.dataset.baInit === '1') return;
      frame.dataset.baInit = '1';
      var range = frame.querySelector('[data-ba-range]');
      if (!range) return;
      function apply() {
        frame.style.setProperty('--ba-pos', range.value + '%');
      }
      range.addEventListener('input', apply);
      apply();
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-ba-frame]').forEach(initFrame);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    // Re-init when re-rendered inside the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
